export default __webpack_public_path__ + "static/media/metal.801b1282.jpg";